import getCardDetailService from '../services/components/card_detail_service.jsx'


const getState = (cardDetailState) => ({ type: "CARD_DETAILSTATE", cardDetailState})


export const getCardDetailAction = (cardRefNo) => dispatch => {
    let state = []
    getCardDetailService((data, msg) => {
        if (msg === "success") {
            console.log(data)
            state = {
                message: "Success",
                status: 200,
                body: data
            }
        }
        else if (msg === "error") {
            state = {
                message: "Empty Body",
                status: 204,
                body: data
            }
        }
        else if(msg === "sessionout"){
            state={
                message: "sessionout",
                status: 401,
                body: data 
            }
        }
        dispatch(getState(state))
    }, cardRefNo)
}




// WEBPACK FOOTER //
// ./src/actions/carddetailaction.jsx